// extracted by mini-css-extract-plugin
export var csatScore = "_ln-5";
export var header = "_ln-1";
export var panelWrapper = "_ln-2";
export var postPreview = "_ln-3";
export var rightContent = "_ln-0";
export var wrappingText = "_ln-4";